import React, { useState } from "react";
import InwardInteraction from "../Nip-Inward-interaction/Inward";
import OutwardInteraction from "./Outward";

const Interaction = () => {
  const [state, setstate] = useState({
    active1: true,
    active2: false,
    route: "",
  });

  const setActiveClass1 = () => {
    setstate({
      ...state,
      active1: true,
      active2: false,
    });
  };

  const setActiveClass2 = () => {
    setstate({
      ...state,
      active1: false,
      active2: true,
    });
  };

  return (
    <div className="nip-home-interaction">
      <div className="nip-home-interaction-header">
        <div className="nip-home-interaction-header-title">Test Procedure</div>
        <div className="nip-home-interaction-header-subtitle">
          Here’s a step by step procedure during NIP Tests that will be carried
          out.
        </div>
      </div>
      <div className="nip-home-interaction-body">
        <div className="test-sec">
          <div className="test-links">
            <div
              className={state.active1 ? "bottom-green" : "test-links-out"}
              onClick={setActiveClass1}
            >
              Outward Test
            </div>
            <div
              className={state.active2 ? "bottom-green" : "test-links-out"}
              onClick={setActiveClass2}
            >
              Inward Test
            </div>
          </div>
          <div className="test-links-sub">
            Here’s a step by step procedure during{" "}
            {state.active1 ? "Outward" : "Inward"} NIP Tests
          </div>
        </div>

        {state.active1 ? (
          <div>
            <OutwardInteraction />
          </div>
        ) : (
          <div>
            <InwardInteraction />
          </div>
        )}
      </div>
    </div>
  );
};

export default Interaction;
